import axios from 'axios'
import api_routes from '../../assets/js/api_routes';
import index from '../index';
const userActions = {
        login({ commit }, user) {
                //TODO this function need refactoring: use Async Await
                return new Promise((resolve, reject) => {
                        commit('auth_request')
                        axios.post(api_routes.login,user)
                        .then(resp => {
                                const token = resp.data.token
                                const user = resp.data.user
                                localStorage.setItem('access_token', token)
                                axios.defaults.headers.common['Authorization'] = token
                                commit('auth_success', token, user)
                                resolve(resp)
                        }).catch(err => {
                                commit('auth_error')
                                alert(err)
                                localStorage.removeItem('access_token')
                                reject(err)
                        })
                })
        },

        async logout({ commit }) {
                commit('logout')
                let token_data ={
                        token: localStorage.access_token
                };
                await axios.post(api_routes.logout,token_data)
                localStorage.removeItem('access_token')
                delete axios.defaults.headers.common['Authorization']
        },
        sidebar_state({ commit },task) {
                //TODO this function need refactoring: use Async Await
                if (task == 'start') {
                        commit('start_sidebar')
                }
                else if(task == 'close') {
                        commit('close_sidebar')
                }
        },
        async createUser({ commit }, payload) {
                try {
                    commit('change_state_loading')
                    const head = {
                        token: localStorage.access_token,
                        name: payload.name,
                        last_name: payload.last_name,
                        identification_document: payload.identification_document,
                        institution: payload.institution,
                        password: payload.password,
                        email: payload.email,
                        rol: payload.rol
                        }
                    const response = await axios.post(api_routes.createUser, head)
                    if (response.data.status === "ok") {
                                commit('activate_toast')
                        } else {
                                commit('activate_error_user_create')
                        }
                    commit('change_state_loading')
                } catch (error) {
                    commit('change_state_loading')
                    commit('activate_error_user_create')
                    throw error
                }
        },
        async deleteUser({commit}, id){
                try {
                        commit('change_state_loading')
                        const token = localStorage.access_token
                        const response = await axios.post(api_routes.deleteUser, {token, id})
                        if (response.data.status === "ok") {
                                commit('activate_toast')
                        } else {
                                commit('activate_error_delete_user')
                        }
                        commit('change_state_loading')
                } catch (error) {
                        commit('change_state_loading')
                        commit('activate_error_delete_user')
                        throw error
                }
        },
        async getUsers({ commit }){
                const token = localStorage.access_token
                const data = await axios.post(api_routes.getUsers, {token})
                commit('get_users', data.data.data)
        },
        async updatePassword({ commit}, payload){
                const head = {
                        token: localStorage.access_token,
                        id: payload.id,
                        new_password: payload.password
                }
                try {
                        commit('change_state_loading')
                        const response = await axios.put(api_routes.updateUserPassword, head)
                        if (response.data.status === "ok") {
                                commit('activate_toast')
                        } else {
                                commit('activate_error_password')
                        }
                        commit('change_state_loading')
                } catch (error) {
                        commit('change_state_loading')
                        commit('activate_error_password')
                        throw error
                }
        },
        async activeUser(payload){
                const head = {
                        token: localStorage.access_token,
                        id: payload.id,
                        active: true
                }
                const data = await axios.post(api_routes.activeUser,head)
                return data
        },
        async inactiveUser(payload){
                const head = {
                        token: localStorage.access_token,
                        id: payload.id,
                        active: false
                }
                const data = await axios.post(api_routes.activeUser,head)
                return data
        },
        requestPasswordReset({ commit }, email) {
                return new Promise((resolve, reject) => {
                        axios.post(api_routes.request_password_reset, email)
                        .then(response => {
                                const rememberToken = response.data.rememberToken
                                commit('change_remember_token', rememberToken)
                                resolve(response)
                        }).catch(error => {
                                commit('activate_error_range')
                                reject(error)
                        })
                })
        },
        passwordReset({ commit }, context){
                const rememberToken = index.state.rememberToken
                const password = context
                return new Promise((resolve, reject) => {
                        axios.post(api_routes.password_reset, {rememberToken, password})
                        .then(response => {
                                commit('activate_toast')
                                resolve(response)
                        }).catch(error => {
                                commit('activate_error_password')
                                reject(error)
                        })
                })
        },
        async getRole({ commit }) {
                const data = await axios.post(api_routes.get_role_list)
                commit('add_role_list', data.data)
        }
}
export default userActions
